module.exports = __webpack_public_path__ + "img/account.5f39759d.svg";